import ConnectorsAPI from '../../api/agents/connectors';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isTesting: false,
  },
  connectorTypes: {},
  availableTools: {},
};

const getters = {
  getConnectors: $state => $state.records,
  getConnectorById: $state => id =>
    $state.records.find(c => c.id === Number(id)),
  getConnectorsByType: $state => type =>
    $state.records.filter(c => c.connector_type === type),
  getUIFlags: $state => $state.uiFlags,
  getConnectorTypes: $state => $state.connectorTypes,
  getAvailableTools: $state => $state.availableTools,
};

const actions = {
  async fetchConnectors({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await ConnectorsAPI.get();
      commit('SET_CONNECTORS', response.data.connectors);
      commit('SET_CONNECTOR_TYPES', response.data.connector_types);
      commit('SET_AVAILABLE_TOOLS', response.data.available_tools);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async createConnector({ commit }, connector) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await ConnectorsAPI.create(connector);
      commit('ADD_CONNECTOR', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async updateConnector({ commit }, { id, ...data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await ConnectorsAPI.update(id, data);
      commit('UPDATE_CONNECTOR', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async deleteConnector({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await ConnectorsAPI.delete(id);
      commit('REMOVE_CONNECTOR', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async testConnection({ commit }, id) {
    commit('SET_UI_FLAG', { isTesting: true });
    try {
      const response = await ConnectorsAPI.testConnection(id);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isTesting: false });
    }
  },
};

const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  SET_CONNECTORS($state, connectors) {
    $state.records = connectors;
  },

  SET_CONNECTOR_TYPES($state, types) {
    $state.connectorTypes = types;
  },

  SET_AVAILABLE_TOOLS($state, tools) {
    $state.availableTools = tools;
  },

  ADD_CONNECTOR($state, connector) {
    $state.records.push(connector);
  },

  UPDATE_CONNECTOR($state, connector) {
    const index = $state.records.findIndex(c => c.id === connector.id);
    if (index !== -1) {
      $state.records.splice(index, 1, connector);
    }
  },

  REMOVE_CONNECTOR($state, id) {
    $state.records = $state.records.filter(c => c.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
